import { gsap } from 'gsap';

export default {
  init() {
    const containersItems = document.getElementsByClassName('items-containers');
    for (const item of containersItems) {
      const containerItems = document.getElementById(item.id);
  if (!containerItems) {
      return;
    }

    const containerLength = containerItems.children.length;

      // Function to clear the styles for the current icon, item container, and progress bar
      function clearStyles(index) {
        const itemProgressBar = document.getElementById(
          `${item.id}-progress-bar-${index}`,
        );
        const itemContainer = document.getElementById(
          `${item.id}-item-${index}`,
        );
        const itemIcon = itemContainer.children[0].children;

        if (itemIcon) itemIcon[0].style.stroke = 'rgb(67, 67, 67)';
        if (itemContainer) itemContainer.style.background = 'transparent';
        if (itemProgressBar) itemProgressBar.style.height = '0%';
      }

      // Function to restart the animation loop
      function restartAnimationLoop() {
        const prevImage = document.getElementById(
          `${item.id}-asset-${containerLength - 1}`,
        );
        prevImage.classList.remove('lg:block');
        const image = document.getElementById(`${item.id}-asset-${0}`);
        image.classList.add('lg:block');
        setTimeout(() => {
          let i = 1;
          while (i <= containerLength) {
            clearStyles(i - 1);
            i++;
          }
          if (i >= containerLength) {
            setTimeout(() => {
              startAnimationLoop(1);
            }, 500);
          }
        }, 1000);
      }

      // Function to start the animation loop
      function startAnimationLoop(index = 0) {
        if (index > containerLength) {
          // Restart the animation loop when the last animation is done
          restartAnimationLoop();
          return;
        }

        if (index > 1) {
          // Clear the styles for the previous item when the index is greater than 1
          const prevImage = document.getElementById(
            `${item.id}-asset-${index - 2}`,
          );
          prevImage.classList.remove('lg:block');
        }

        const barId = `${item.id}-progress-bar-${index - 1}`;
        const assetId = `${item.id}-asset-${index - 1}`;
        const itemId = `${item.id}-item-${index - 1}`;
        const image = document.getElementById(assetId);
        const containerItem = document.getElementById(itemId);
        const itemIcon = containerItem.children[0].children;
        const itemProgressBar = document.getElementById(barId);

        // This should be the image that is currently being displayed
        image.classList.add('lg:block');

        // Set the styles for the current icon
        gsap.to(itemIcon, {
          stroke: '#FF7F50', // Trailing comma added here
        });

        // Set the styles for the current item container
        gsap.to(containerItem, {
          background: '#FFECE5',
          duration: 0.5,
          transitionTimingFunction: 'ease-in-out', // Trailing comma added here
        });

        // Set the styles for the current progress bar
        gsap
          .timeline()
          .addLabel('start')
          .to(itemProgressBar, {
            height: '100%',
            duration: 5,
            onComplete: () => {
              // Move to the next animation
              startAnimationLoop(index + 1);
            }, // Trailing comma added here
          });
      }

      // Start the animation loop
      startAnimationLoop(1);
    }
  },
};
